import React from 'react'
import { TableInfoRow } from '@/ui/atoms/Table/TableRow/tableInfoRow'

export type TableRowProps = {
  label?: string
  value?: string
  valueRichText?: any
  useRichText?: boolean
  className?: string
  valueClassName?: string
}

export const TableRow: React.FC<TableRowProps> = ({ label, value, valueRichText, useRichText, className, valueClassName }) => {
  return (
    <TableInfoRow
      label={label}
      value={value}
      valueRichText={valueRichText}
      useRichText={useRichText}
      className={className}
      valueClassName={valueClassName}
    />
  )
}
